<template>
  <div>
    <label class="section-title -mt-large -mb">Responses:</label>
    <div v-for="(response, index) in editableResponses" :key="index">
      <input v-model="response.message" type="text" @keyup="change" />
      <span v-if="responseError(index)" class="alert -inline -danger">Response {{ responseError(index) }}</span>
      <a href="#" class="button -danger -small" @click.prevent="removeResponse(response)">Remove</a>
      <hr />
    </div>

    <a href="#" class="button -small -mb" @click.prevent="addResponse">Add response</a>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

export default {
  name: "QueryResponses",

  props: {
    query: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      editableResponses: [],
      editableErrors: []
    };
  },

  watch: {
    query() {
      this.setEditableResponses();
    },

    errors() {
      this.editableErrors = this.errors;
    }
  },

  mounted() {
    this.setEditableResponses();
  },

  methods: {
    responseError(index) {
      return dig(this.editableErrors, this.type, "responses", index, "message", 0);
    },

    addResponse(type) {
      this.editableResponses.push({ message: "" });
      this.change();
    },

    removeResponse(response) {
      this.editableResponses = _.without(this.editableResponses, response);
      this.change();
    },

    change() {
      this.editableErrors = {};
      this.$emit("change", this.editableResponses);
    },

    setEditableResponses() {
      this.editableResponses = dig(this.query, this.type, "responses");
    }
  }
};
</script>
